import { useEffect, useState } from "react";
import api from "../services/api";

// The company's transaction lock date (Company Profile), or "" when none is set. Transactions dated on or before it are
// frozen: the server refuses to change them, so the pages do not offer the buttons.
export const useTransactionLockDate = () => {
  const [lockDate, setLockDate] = useState("");
  useEffect(() => {
    let cancelled = false;
    api
      .get("/api/v1/distributor-profile")
      .then((data) => {
        if (!cancelled) setLockDate(data?.transactionLockDate || "");
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return lockDate;
};

// Both are yyyy-mm-dd, so they compare as text.
export const isLockedDate = (date, lockDate) => Boolean(date && lockDate && date <= lockDate);
